import { schema } from 'normalizr';

const VirtualMembersipSchema = new schema.Entity('virtualMemberships', {});
const AutoShareSchema = new schema.Entity('autoShares', {});

export { VirtualMembersipSchema, AutoShareSchema };
